const featuresData = [
    {
      image: 'assets/images/nft/article-01.png',
      title: 'Sibu\'s Sky Dancers',
      content: 'Discovering the Unique Bird Species of Sibu, Sarawak',
    },
    {
      image: 'assets/images/nft/article-02.png',
      title: 'Feathered Gems of Sibu',
      content: 'A Beginner\'s Guide to Bird Watching in Sarawak\'s Lush Landscapes',
    },
    {
      image: 'assets/images/nft/article-03.png',
      title: `Backyard Birding`,
      content: 'Exploring Sibu\'s Rich Avian Diversity at Your Backyards',
    },
    {
      image: 'assets/images/nft/article-04.png',
      title: `Winged Wonders of Sibu`,
      content: 'Unveiling the Best Bird Watching Spots in Sarawak',
    },
  ];

  export { featuresData };
